module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error",
    class: _vm.type === 'tip' ? 'yellow' : 'red',
    style: ({
      width: (_vm.type === 'tip') ? '260px' : '300px'
    })
  }, [_c('span', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [(_vm.type === 'tip') ? _c('img', {
    attrs: {
      "src": require("../../assets/images/new-login-2018/yellow_close.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/new-login-2018/red_close.png")
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8fe7c2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/components/Error.vue
// module id = 752
// module chunks = 1